import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseItemsSearch } from "@/features/content";
import { NewsListPage } from "@/features/content/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/news/")({
  validateSearch: strictSearch(parseItemsSearch),
  component: News,
});

function News() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <NewsListPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(newsId) =>
        router.buildLocation({ to: "/growth/news/$newsId", params: { newsId } }).href
      }
      onOpen={(newsId) => void router.navigate({ to: "/growth/news/$newsId", params: { newsId } })}
      onNew={() => void router.navigate({ to: "/growth/news/new" })}
    />
  );
}
